import { useMatrix } from '@/core/domain/enterprise/Matrix/Matrix.hooks';

import { RegistrationsDefaultCode } from '@/types/Register';
import { PartItemFieldOption } from '@/core/domain/stock/Configuration/Configuration.types';
import { RequestPurchaseFieldOption } from '@/core/domain/workorder/RequestPurchase/RequestPurchase.types';

interface Props {
  manufacturingCode?: string[] | string;
  barcode?: string[] | string;
  internalCode?: string[] | string;
  companyCode?: string[] | string;
  sku?: string[] | string;
  isRequestPurchase?: boolean;
  isSku?: boolean;
  isSorter?: boolean;
  widthColumns?: number;
  columnsKey?: {
    manufacturingCode: React.Key;
    barcode: React.Key;
    companyCode: React.Key;
    sku: React.Key;
  };
}

const useConfigurationColumnsPart = ({
  manufacturingCode = 'manufacturingCode',
  barcode = 'barcode',
  internalCode = 'internalCode',
  companyCode = 'companyCode',
  sku = 'sku',
  isRequestPurchase,
  isSku,
  isSorter = true,
  widthColumns = 150,
  columnsKey,
}: Props) => {
  const { data } = useMatrix();

  if (
    data?.matrixSettings.defaultPartCode ===
    RegistrationsDefaultCode.manufacturerCode
  ) {
    return {
      key:
        columnsKey?.manufacturingCode ||
        (isRequestPurchase
          ? RequestPurchaseFieldOption.manufacturingCode
          : PartItemFieldOption.ManufacturingCode),
      dataIndex: manufacturingCode,
      title: 'Cód. Fabricante',
      ellipsis: true,
      width: widthColumns,
      sorter: isSorter,
      render: (value: number) => (value ? value : '-'),
    };
  }

  if (
    data?.matrixSettings.defaultPartCode === RegistrationsDefaultCode.barCode
  ) {
    return {
      key:
        columnsKey?.barcode ||
        (isRequestPurchase
          ? RequestPurchaseFieldOption.barCode
          : PartItemFieldOption.BarCode),
      dataIndex: barcode,
      title: 'Cód. Barras',
      ellipsis: true,
      width: widthColumns,
      sorter: isSorter,
      render: (value: number) => (value ? value : '-'),
    };
  }

  if (
    data?.matrixSettings.defaultPartCode ===
    RegistrationsDefaultCode.companyCode
  ) {
    return {
      key:
        columnsKey?.companyCode ||
        (isRequestPurchase
          ? RequestPurchaseFieldOption.companyCode
          : PartItemFieldOption.companyCode),
      dataIndex: companyCode,
      title: 'Cód. Empresa',
      ellipsis: true,
      width: widthColumns,
      sorter: isSorter,
      render: (value: number) => (value ? value : '-'),
    };
  }

  if (
    data?.matrixSettings.defaultPartCode ===
    RegistrationsDefaultCode.internalCode
  ) {
    return {
      key:
        columnsKey?.sku ||
        (isRequestPurchase
          ? RequestPurchaseFieldOption.internalCode
          : isSku
          ? RequestPurchaseFieldOption.sku
          : PartItemFieldOption.OriginalCode),
      dataIndex: isSku ? sku : internalCode,
      title: 'Cód. Interno',
      ellipsis: true,
      width: widthColumns,
      sorter: isSorter,
      render: (value: number) => (value ? value : '-'),
    };
  }

  return {
    key: columnsKey?.sku || RequestPurchaseFieldOption.sku,
    dataIndex: sku,
    title: 'Cód. Interno',
    ellipsis: true,
    width: widthColumns,
    sorter: isSorter,
    render: (value: number) => (value ? value : '-'),
  };
};

export default useConfigurationColumnsPart;
